<template>
<div class="w-full h-full overflow-x-auto storyblok-rich-text-table">
  <table class="w-full table-fixed2 whitespace-nowrap">
    <thead v-if="hasHeaders">
      <tr>
        <th :key="th._uid" v-for="th in input.thead">{{replaceApostrophe(th.value)}}</th>
      </tr>
    </thead>
    <tbody>
      <tr :key="tr._uid" v-for="(tr, idx) in input.tbody" :style="idx % 2 === 0 ? altRow : {}">
        <td :key="td._uid" v-for="td in tr.body">{{ replaceApostrophe(td.value)}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
  name: "tabular-data",
  props: {
    data: {
      type: Object,
    },
    blok: {
      type: Object
    }
  },
  mounted() {},
  methods: {
    replaceApostrophe(value) {
      if (!value) {
        return '';
      }
      return value;
      // return value.toString().replace(/&apos;/g, "'");
    },
  },
  filters: {
    replaceLineBreaks(value) {
      if (!value) {
        return '';
      }
      return value.replace(/(?:\r\n|\r|\n)/g, `&lt;br&gt;`);
    }
  },
  computed: {
    hasHeaders() {
      return this.input.thead.map(h => h.value).filter(Boolean).length;
    },
    altRow() {
      if (this.blok) {
        return { backgroundColor: this.blok.alternative_row_color ? this.blok.alternative_row_color.trim() : "transparent" };
      }
      return {}
    },
    input() {
      return this.blok ? this.blok.data : this.data;
    }
  }
}
</script>

<style>
/* These styles CANNOT be scoped since the rich text table could potentially be rendered inside "v-runtime-template" */
/* Instead, give the  surrounding div a very specific class name to target elements inside the rendered rich text, */
/* and not interfere with other styles in the system - since it is not scoped. */
.storyblok-rich-text-table {
  overflow: auto;
  width: 100%;
}
.storyblok-rich-text-table table, th, td {
  border: 1px solid #dedede;
}
.storyblok-rich-text-table table {
  width: 100%;
}
.storyblok-rich-text-table th, td {
  padding: 4px 8px;
}
.storyblok-rich-text-table td {
  font-size: 14px;
  white-space: pre;
   /* word-break: break-word; */
  /* overflow-wrap: break-word; */
  /* white-space: normal; */
}
.storyblok-rich-text-table thead {
  padding: 6px 8px;
  font-size: 0.85rem;
   font-family: Inter;
   text-align: left;
}
</style>
